import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AlarmService } from '../../../../../../../services/alarm.service';
import { ButtonIconComponent } from '../../../../../../../shared/components/button-icon/button-icon.component';
import { InputSelectComponent } from '../../../../../../../shared/components/input-select/input-select';
import { TranslateSafePipe } from '../../../../../../../shared/pipes/translation.pipe';
import {
  AlarmRuleActionEmailConfig,
  AlarmRuleActionResolvedAlarm,
} from '../../../../../../../types/dtos/alarm-rule-action.dto';
import { AlarmType } from '../../../../../../../types/enums/alarm.enum';
import { InputSelectInterface } from '../../../../../../../types/interfaces/input.interface';
import { BaseAction } from '../base-action';
import { BaseRuleAction } from '../base-rule-action';
import { AlarmResolvedRuleAction } from './alarm-resolved.rule-action';

@Component({
  selector: 'app-alarm-resolved',
  imports: [
    InputSelectComponent,
    ButtonIconComponent,
    TranslateSafePipe,
  ],
  templateUrl: './alarm-resolved.html',
  styleUrls: [
    './alarm-resolved.css',
    '../base-rule-action.css',
  ],
})
export class AlarmResolved extends BaseAction {
  override ruleAction: BaseRuleAction = new AlarmResolvedRuleAction();
  private readonly _alarmService: AlarmService = inject(AlarmService);
  private readonly _translateService: TranslateService = inject(TranslateService);

  public get getDefaultValueString(): string {
    let config: AlarmRuleActionResolvedAlarm | undefined = this.getConfig();
    return config?.alarmType ? this._translateService.instant('common.enum.alarm-type.' + config.alarmType) : '-';
  }

  public getAlarmTypeInput(): InputSelectInterface {
    return {
      formGroup: this.formGroup,
      id: 'alarmType',
      isTranslated: true,
      label: 'common.table.alarm-type.label',
      required: true,
      options: Object.values(AlarmType)
        .map((key) => ({
          isTranslated: true,
          label: 'common.enum.alarm-type.' + key,
          value: key,
        })),
    };
  }
}
